import { logger as LOG } from '@garnish/logger';
import { assign } from 'xstate5';

import { type Action, type UpdateManifest } from '../ota-update-state-machine.types';

// ─── Actions ─────────────────────────────────────────────────────────────────

const onCheckForUpdateDone: Action<{ manifest: UpdateManifest | undefined }> = assign(
  (_args, params) => {
    const { manifest } = params;
    const appConfig = manifest?.extra?.expoClient;

    const id = manifest?.id;
    const targetVersion = appConfig?.version;

    return {
      availableUpdate: { id, targetVersion },
    };
  },
);

const onCheckForUpdateError: Action = () => {
  logger.debug('Failed to check for an update');
};

const onRestartAppError: Action = () => {
  logger.error('Failed to restart the app');
};

// ─────────────────────────────────────────────────────────────────────────────

export const Actions = {
  onCheckForUpdateDone,
  onCheckForUpdateError,
  onRestartAppError,
};

// ─── Logger ──────────────────────────────────────────────────────────────────

export const logger = LOG.extend('OTA UPDATE STATE MACHINE');
